import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../../utils/rel';

class AutoSearch extends React.PureComponent {
    state = {
        searchTxt: '输入品牌或车系',
    };

    handleChange = e => {
        const val = e.currentTarget.value;

        this.setState({ searchTxt: val });
    };

    handleKeydown = e => {
        const val = e.currentTarget.value ? e.currentTarget.value : '';

        if (e.keyCode === 13) window.open(`http://data.auto.ifeng.com/search/search.do?keywords=${val}#index3`);
    };

    handleFocus = e => {
        const val = e.currentTarget.value;

        this.setState({
            searchTxt: val === '输入品牌或车系' ? '' : val,
        });
    };

    handleBlur = e => {
        const val = e.currentTarget.value;

        this.setState({
            searchTxt: val === '' ? '输入品牌或车系' : val,
        });
    };

    handleClick = e => {
        const val =
            e.currentTarget.attributes['txt'].value !== '输入品牌或车系' ? e.currentTarget.attributes['txt'].value : '';

        window.open(`http://data.auto.ifeng.com/search/search.do?keywords=${val}#index3`);
    };

    render() {
        const { searchTxt } = this.state;

        return (
            <div className={styles.auto_search}>
                <span>
                    <input
                        className={styles.txt}
                        type="text"
                        value={searchTxt}
                        onChange={this.handleChange}
                        onKeyDown={this.handleKeydown}
                        onFocus={this.handleFocus}
                        onBlur={this.handleBlur}
                    />
                </span>
                <span>
                    <input className={styles.btn} type="button" txt={searchTxt} onClick={this.handleClick} />
                </span>
            </div>
        );
    }
}

export default errorBoundary(AutoSearch);
